import Flex from '@decisiv/ui-components/lib/components/Flex';
import Pagination from '@decisiv/ui-components/lib/components/Pagination';

import { usePaginatedList } from 'hooks/usePaginatedList';
import AssetRow from '../../components/AssetRow';

import { Container } from './styles';
import { useAddAssetContext } from '../../context/AddAssetContext';
import { ITEMS_PER_PAGE } from '../constants';

export default function InvalidVins() {
  const {
    savedState: {
      stepTwo: { invalidVins },
    },
  } = useAddAssetContext();

  const { activePage, items, setCurrentPage, totalPages } = usePaginatedList({
    items: invalidVins,
    perPage: ITEMS_PER_PAGE,
  });

  return (
    <>
      <Container>
        {items.map(({ vin, reason }) => (
          <AssetRow key={vin} vin={vin} reason={reason} />
        ))}
      </Container>
      {totalPages > 1 && (
        <Flex marginTop={1} alignSelf="flex-end">
          <Pagination
            totalPages={totalPages}
            activePage={activePage}
            onPageChange={setCurrentPage}
            defaultActivePage={1}
          />
        </Flex>
      )}
    </>
  );
}
